import React from 'react';
import classnames from 'classnames';
import s from './BulletItem.scss';
var BulletItem = function (_a) {
    var bullet = _a.bullet, children = _a.children, className = _a.className, textClassName = _a.textClassName;
    return (React.createElement("li", { className: classnames(s['item'], className) },
        bullet && (React.createElement("span", { className: s['bullet'], "aria-hidden": true }, bullet)),
        React.createElement("span", { className: classnames(s['text'], textClassName) }, children)));
};
BulletItem.displayName = 'IconBullet';
export default BulletItem;
//# sourceMappingURL=BulletItem.js.map